module.exports = __webpack_public_path__ + "img/home-active.0a7bc50a.png";